function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/%E2%9D%96-Web-Component-Library?node-id=10734%3A13144
import defaultTheme from '@chakra-ui/theme';
var {
  colors: {
    black,
    blackAlpha,
    current,
    transparent,
    whiteAlpha,
    white
  }
} = defaultTheme;
var commonColors = {
  black,
  blackAlpha,
  current,
  transparent,
  white,
  whiteAlpha
};
var brandColors = {
  primary: {
    100: '#EFF8FC',
    200: '#AFDBF1',
    500: '#1998D5',
    400: '#1476AD',
    700: '#10628A'
  },
  secondary: {
    100: '#FEF4EE',
    200: '#FACAAB',
    500: '#F1670D',
    400: '#C74E00',
    700: '#9C4308'
  },
  tertiary: {
    300: '#F6F8FA',
    500: '#DEE5EC',
    700: '#81919F'
  },
  neutral: {
    50: '#FAFBFC',
    100: '#ECECEC',
    200: '#BDBDBD',
    300: '#6E6E6E',
    500: '#424242'
  }
};
var validationColors = {
  negative: {
    100: '#FCEFEF',
    200: '#F0B2AF',
    500: '#D4231A',
    400: '#A72721',
    700: '#7C1212'
  },
  positive: {
    100: '#EFF6EF',
    200: '#AED3AF',
    300: '#40A142',
    400: '#157217',
    500: '#178019',
    700: '#22580E'
  },
  caution: {
    500: '#FDD835'
  }
};
export var colors = _extends({}, commonColors, brandColors, validationColors);
//# sourceMappingURL=colors.js.map